import { Container } from "react-bootstrap"
import React from "react";
import { withRouter } from "react-router-dom"

export const Contact = () => {
    return (
        <Container
            className="d-flex flex-column justify-content-center align-self-center align-items-center w-100 textSmall textFont box p-5 mb-5"
            style={{maxWidth: "60rem"}}>
            <h3>Dane kontaktowe:</h3>
            <br/>
            <p>
                <a className="textMedium" href="mailto:custommapholder@gmail.com">custommapholder@gmail.com</a>
                <br/>
                <br/>
                M MACHINES Łukasz Mirowski
                <br/>
                ul. Piwnika-Ponurego 77/1
                <br/>
                51-321 Wrocław, Polska
                <br/>
                NIP: 771 26 52 955
                <br/>
            </p>
            <br/>
        </Container>
    )
}

export default withRouter(Contact)